import { useQuery } from "react-query";
import { getCancellationReasons } from "api/appointments";

const CANCELLATION_REASONS = "cancellation-reasons";

export default function useGetCancellationReasons(recurringOnly = false) {
  const { data, ...rest } = useQuery(
    [CANCELLATION_REASONS, recurringOnly],
    () => getCancellationReasons({ recurringOnly }),
    {
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );

  return {
    cancellationReasons: data?.data,
    ...rest,
  };
}